import { FC, useState } from 'react';
import { useForm } from 'react-final-form';
import { RadioField } from 'components/Forms/RadioField';
import { DateTimeField } from 'components/Forms/DateTimeField';
import { useFieldValue } from 'hooks/useFormHelpers';

interface Props {
  startTimeValidator: (value: any) => string | undefined;
  endTimeValidator: (value: any) => string | undefined;
  doorsOpenTimeValidator: (value: any) => string | undefined;
}

export const TimePickersForm: FC<Props> = ({
  startTimeValidator,
  endTimeValidator,
  doorsOpenTimeValidator,
}) => {
  const form = useForm();
  const { change } = form;
  const [endTimeKey, setEndTimeKey] = useState(0);
  const doorsOpenBeforeEvent = useFieldValue('doors_open_before_event');
  const endTime = useFieldValue('end_time');

  const clearEndTime = () => {
    change('end_time', '');
    setEndTimeKey(prev => prev + 1); // Force re-render
  };

  const doorsOpenOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No, they open at the same time as the event' },
  ];

  return (
    <>
      <div className="row">
        <div className="col-md-4 padding0">
          <DateTimeField
            name="start_time"
            label="Start Time"
            placeholder="Time Picker Here"
            required
            validate={startTimeValidator}
            timeFormat={true}
            dateFormat={false}
            closeOnSelect
            readOnly
          />
        </div>
        <div className="col-md-2" />
        <div className="col-md-4 padding0">
          <DateTimeField
            key={endTimeKey}
            name="end_time"
            label="End Time (optional)"
            placeholder="Time Picker Here"
            validate={endTimeValidator}
            timeFormat={true}
            dateFormat={false}
            closeOnSelect
            readOnly
          />
          {endTime && (
            <div className="row">
              <button
                type="button"
                className="oath-utility link-text gray padding0"
                onClick={clearEndTime}
              >
                Clear End Time
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="col-md-4 padding0">
        <DateTimeField
          name="doors_open_datetime"
          label="Doors Open Time"
          placeholder="Time Picker Here"
          required
          validate={doorsOpenTimeValidator}
          timeFormat={true}
          dateFormat={false}
          closeOnSelect
          readOnly={doorsOpenBeforeEvent}
          disabled={!doorsOpenBeforeEvent}
          forceDirty={form.getState().dirtyFields?.doors_open_before_event}
        />
      </div>
      <div className="col-md-4 padding0">
        <RadioField
          name="doors_open_before_event"
          label="Doors open before event starts?"
          options={doorsOpenOptions}
        />
      </div>
    </>
  );
};
